import { render, staticRenderFns } from "./AddPandiCheckup.vue?vue&type=template&id=2e4850cb&scoped=true&"
import script from "./AddPandiCheckup.vue?vue&type=script&lang=js&"
export * from "./AddPandiCheckup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4850cb",
  null
  
)

export default component.exports